export const populateDisplayName = item => {
  return { ...item, displayName: checkStoreType(item.storeSuffix, item.preferredName || item.tradingName) }
}

export const checkStoreType = (storeSuffix, displayName) => {
  return storeSuffix ? displayName + ' (' + storeSuffix + ')' : displayName
}
